import React, { useEffect, useState } from "react";
import { Container } from "react-bootstrap";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faTimesCircle, faInfoCircle } from "@fortawesome/free-solid-svg-icons";
import { StyledWrapper } from "./GlobalAlertHelpers";
import { graphql, useStaticQuery } from "gatsby";
import { useGlobalAlertSliceContext } from "../../../context/SliceContexts/GlobalAlertContext";

const GlobalAlert = (): JSX.Element | false => {
  const { brand } = useGlobalAlertSliceContext();

  const data = useStaticQuery(graphql`
    {
      allNodeAlerts(
        filter: {
          relationships: {
            field_site_list: { machine_name: { eq: "sonesta" } }
          }
        }
      ) {
        nodes {
          id
          title
          body {
            value
          }
          field_date {
            end_value
            value
          }
          created
          relationships {
            field_brand_list {
              id
              name
              brand_code
            }
            field_site_list {
              machine_name
            }
          }
        }
      }
    }
  `);
  const alerts = data.allNodeAlerts.nodes;
  const [alertMessage, setAlertMessage] = useState();
  const [hideBanner, setHideBanner] = useState(true);
  const handleClose = () => {
    setHideBanner(true);
    const storeObj = {
      dismissed: true,
      message: alertMessage,
    };
    sessionStorage[`${alertMessage.id}_alertMessage`] =
      JSON.stringify(storeObj);
  };

  function isBrand(alert: any) {
    const brandList = alert.relationships.field_brand_list;
    return brandList?.find(
      ({ brand_code }: { brand_code: string }) =>
        brand_code === brand.brand_code
    );
  }

  useEffect(() => {
    const alertList = [...alerts];
    alertList.sort(function (a, b) {
      if (a.created < b.created) {
        return 1;
      }
      if (a.created > b.created) {
        return -1;
      }
      return 0;
    });
    if (brand) {
      const brandAlert = alertList.find(isBrand);
      setAlertMessage(brandAlert);
    } else if (window.location.pathname == "/") {
      setAlertMessage(alertList[0]);
    } else if (alertList.length > 0) {
      setAlertMessage(alertList[0]);
    }
  }, []);

  useEffect(() => {
    if (!alertMessage) {
      if (!hideBanner) {
        setHideBanner(true);
      }
    } else {
      let storedObj = sessionStorage[`${alertMessage.id}_alertMessage`];
      if (storedObj) {
        storedObj = JSON.parse(storedObj);
        if (
          storedObj.message.title === alertMessage.title &&
          storedObj.message.body.value === alertMessage.body.value
        ) {
          !storedObj.dismissed && setHideBanner(false);
        } else {
          if (hideBanner) {
            setHideBanner(false);
          }
        }
      } else if (hideBanner) {
        setHideBanner(false);
      }
    }
  });
  return (
    !hideBanner && (
      <StyledWrapper className="px-4 px-lg-5 py-3">
        <Container fluid="sm" className="text-left d-flex">
          <FontAwesomeIcon icon={faInfoCircle} />
          {alertMessage && (
            <div
              className="alertMessage"
              dangerouslySetInnerHTML={{ __html: alertMessage.body.value }}
            />
          )}
          {/* <div className='globalIcon'>
                    <FontAwesomeIcon
                        icon={faTimesCircle}
                        size="sm"
                        onClick={handleClose}
                    />
                </div> */}
          <FontAwesomeIcon
            icon={faTimesCircle}
            size="sm"
            onClick={handleClose}
          />
        </Container>
      </StyledWrapper>
    )
  );
};

export default GlobalAlert;
